import DomainCommon from './common';

const GroupTypeService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/groupType`,
                resolve, reject
            });
        });
    },
    findById: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/groupType/${groupId}`,
                resolve, reject
            });
        });
    },
};

export default GroupTypeService;



// WEBPACK FOOTER //
// ./src/service/groupType.js